import {
  mainCategoryCreateSchema,
  mainCategorySchema,
} from "@/schema/console/simple-assessments/MainCategory";
import { z } from "zod";

export const simpleAssessmentDetailSchema = z.object({
  id: z.number(),
  main_categories: z.array(mainCategorySchema),
});

export const simpleAssessmentCreateSchema = z.object({
  is_premium: z.literal(false),
  is_published: z.boolean(),
  main_categories: z.array(mainCategoryCreateSchema),
});

export type SimpleAssessmentDetail = z.infer<
  typeof simpleAssessmentDetailSchema
>;

export type SimpleAssessmentCreate = z.infer<
  typeof simpleAssessmentCreateSchema
>;
